import styled from 'styled-components';
import { Box } from '../box/box';
import { borderRadius } from '../theme/border-radius';
import { shadow } from '../theme/shadow';
import { blur } from '../theme/css';
export const Main = styled.div `
  @apply cursor-pointer select-none flex items-center justify-center h-full;
`;
export const Container = styled.div `
  @apply fixed flex w-auto mx-0 my-auto pointer-events-none items-end flex-col bottom-8 left-8 right-8;

  z-index: 1001;
`;
export const Message = styled(Box) `
  @apply pointer-events-auto box-border relative overflow-hidden mt-2 w-100;

  ${blur};
  border-radius: ${borderRadius.md};
  box-shadow: ${shadow.lg};
`;
export const Content = styled.div `
  color: var(--text-color-0);
  @apply opacity-90 flex flex-col overflow-hidden h-auto text-base py-1 px-4;
`;
export const Operation = styled.div `
  @apply flex justify-end pb-2;
`;
